import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import Layout from "@/components/Layout";
import { Newspaper, BookOpen, Bell } from "@phosphor-icons/react";

const ICONS = {
    "Current Affairs": Newspaper,
    "Study Material": BookOpen,
    "Notification": Bell,
};

export default function StudyMaterial() {
    const [items, setItems] = useState([]);
    const [searchParams] = useSearchParams();
    const [category, setCategory] = useState(searchParams.get("category") || "");

    useEffect(() => {
        (async () => {
            const { data } = await api.get("/study", { params: category ? { category } : {} });
            setItems(data);
        })();
    }, [category]);

    return (
        <Layout>
            <div className="mb-8">
                <div className="text-xs uppercase tracking-widest text-slate-500">Study Material · Current Affairs</div>
                <h1 className="font-heading font-bold text-3xl sm:text-4xl mt-1">Curated for Karnataka aspirants</h1>
                <p className="text-slate-500 mt-2 text-sm">Handpicked notes, budget analyses, and current affairs specific to KPSC & KEA syllabi.</p>
            </div>

            <div className="mb-6 flex flex-wrap gap-2">
                {[["", "All"], ["Current Affairs", "Current Affairs"], ["Study Material", "Study Material"], ["Notification", "Notifications"]].map(([v, l]) => (
                    <button
                        key={l}
                        onClick={() => setCategory(v)}
                        data-testid={`study-filter-${l}`}
                        className={`px-4 py-1.5 rounded-full text-sm border ${category === v ? "border-[#1E3A8A] text-[#1E3A8A] bg-[#1E3A8A]/5" : "border-[#BFD3FF] text-slate-600"}`}
                    >{l}</button>
                ))}
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
                {items.map((m) => {
                    const Icon = ICONS[m.category] || BookOpen;
                    return (
                        <article key={m.material_id} className="bento-card">
                            <div className="flex items-center gap-2 mb-3">
                                <div className="p-1.5 rounded-lg bg-[#1E3A8A]/5 text-[#1E3A8A]"><Icon size={16} weight="duotone" /></div>
                                <div className="text-[10px] uppercase tracking-widest text-[#1E3A8A]">{m.category}</div>
                                <div className="ml-auto text-xs text-slate-500 font-mono">{m.date}</div>
                            </div>
                            <div className="font-heading font-semibold text-lg leading-snug mb-2">{m.title}</div>
                            <p className="text-sm text-slate-600 leading-relaxed">{m.content}</p>
                        </article>
                    );
                })}
                {items.length === 0 && <div className="col-span-full bento-card text-slate-500">No entries yet.</div>}
            </div>
        </Layout>
    );
}
